import FormControl, { FormControlProps } from "react-bootstrap/FormControl";
import { FiSearch } from "react-icons/fi";

export function SearchFormControl({ ...rest }: FormControlProps) {
	return (
		<>
			<FiSearch className="fs-4 text-muted position-absolute mt-4 ms-4" />
			<FormControl type="search" className="ps-12 shadow border-0" {...rest} />
		</>
	);
}
